// extracted by mini-css-extract-plugin
module.exports = {"detailRUActions":"DetailRUActions_detailRUActions__-9_Qo","collect":"DetailRUActions_collect__1WfAn","share":"DetailRUActions_share__1bZH1"};